import {STRINGS} from "../commons/constants/CommonConstants";
import {getStationCode} from "../util/CommonUtils";

const postMessagePromises = {};
function generateGuid() {
    /**
     * @return {string}
     */
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
}

function postMessagePromised(targetWindow, message, targetOrigin, timeout) {
    const newGuid = generateGuid();
    message.guid = newGuid;
    postMessagePromises[newGuid] = {};
    postMessagePromises[newGuid]['promise'] = new Promise(function (resolve, reject) {
        postMessagePromises[newGuid]['resolve'] = resolve;
        postMessagePromises[newGuid]['reject'] = reject;
        targetWindow.postMessage(message, targetOrigin);
        if (timeout) {
            setTimeout(() => {
                postMessagePromises[newGuid].resolve(STRINGS.TIMEOUT);
            }, timeout);
        }
    });
    return postMessagePromises[newGuid].promise;
}

var setCurrentDarkMode = () => {};
export function setDarkModeStateListener(darkModeStateListener) {
  setCurrentDarkMode = darkModeStateListener;
}

export async function getDarkModeStatus() {
    return await postMessagePromised(
      window.parent,
      {
        method: "getDarkModeStatus",
        args: {},
      },
      "*",
    );
  }

export async function getLocaleFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getLocale',
        args: {}
    }, '*', 200);
}

export async function getCountryCodeFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCountryCode',
        args: {}
    }, '*', 200);
}

export async function getAllNodeCapabilitiesFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getAllNodeCapabilities',
        args: {}
    }, '*');
}

export function publishClientSideMetrics(args) {
    window.parent.postMessage({
        method: 'publishClientSideMetrics',
        args: args
    }, "*");
}

export async function getCycleDataFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getCycleDataFromParent',
        args: {}
    }, '*');
}

export async function getAPIGatewayDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getAPIGatewayDataFromParent',
        args: args
    }, '*');
}

export async function getEmployeeName() {
    return await postMessagePromised(window.parent, {
        method: 'getEmployeeName',
        args: {}
    }, '*');
}

export async function getExportResultsDataFromParent(args) {
    return await postMessagePromised(window.parent, {
        method: 'getExportResultsDataFromParent',
        args: args
    }, '*');
}

export function setSelectedCycle(selectedCycle) {
    window.parent.postMessage({
        method: 'setSelectedCycle',
        args: {selectedCycle: selectedCycle}
    }, "*");
}

export async function getTcpRolesFromParent() {
    return await postMessagePromised(window.parent, {
        method: 'getTcpRoles',
        args: {}
    }, '*');
}

export async function getDocumentURL() {
    return await postMessagePromised(window.parent, {
        method: 'getDocumentURL',
        args: {}
    }, '*');
}

export async function getFeaturesFromParent(features) {
    return await postMessagePromised(window.parent, {
        method: 'getFeatureStatus',
        args: {features, ...getStationCode()}
    }, '*');
}

export async function isSafetyReportFeatureEnabled() {
    return await postMessagePromised(window.parent, {
        method: 'isSafetyReportFeatureEnabled',
        args: {}
    }, '*');
}

window.addEventListener("message", onNewPostMessageFromParent, false);

function onNewPostMessageFromParent(event) {
    if (event.data.method && subscribeAbleEvents.hasOwnProperty(event.data.method)) {
        subscribeAbleEvents[event.data.method](event.data);
    }
}

const subscribeAbleEvents = {
    "sendCycleDataToChild": sendCycleDataToChild,
    "sendApiGatewayResponse": sendApiGatewayResponse,
    "sendLocaleResponse": sendResponse,
    "sendCountryCodeResponse": sendResponse,
    "sendDocumentURL": sendDocumentURL,
    "sendFeatureStatus": sendResponseData,
    "sendAllNodeCapabilitiesResponse": sendAllNodeCapabilitiesResponse,
    "sendSafetyReportEnabled": sendSafetyReportEnabled,
    "sendTcpRolesResponse": sendTcpRolesResponse,
    "sendDarkModeStatus": sendDarkModeStatus,
    "sendEmployeeNameResponse": sendEmployeeNameResponse
}

function sendDarkModeStatus(data) {
    if (data.childData.capability === "dark") {
      setCurrentDarkMode("dark");
    } else {
      setCurrentDarkMode("light");
    }
  }

function sendCycleDataToChild(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendTcpRolesResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendAllNodeCapabilitiesResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendApiGatewayResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendDocumentURL(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendResponseData(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.responseData);
    }
}

function sendSafetyReportEnabled(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}

function sendEmployeeNameResponse(data) {
    if (postMessagePromises[data.guid]) {
        postMessagePromises[data.guid].resolve(data.childData);
    }
}


// WEBPACK FOOTER //
// ./src/handler/ParentDataHandler.js